// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__31F7u","col":"CardReaderDesc_col__284oW","label":"CardReaderDesc_label__3gpDM"};